window.app.provider("ngRequire", [
  function() {
    var svc = this;

    this.templates = {
      "header-logo.svg": " ",
      "src/apps/shared/header/header.html": require("../apps/shared/header/header.html"),
      // 'src/apps/shared/menu/menu.html': require('../apps/shared/menu/menu.html'),
      "src/apps/container/views/apps.html": require("../apps/container/views/apps.html"),
      "src/apps/news/views/desktop/home-feed.html": require("../apps/news/views/desktop/home-feed.html"),
      "src/apps/news/views/mobile/home-feed.html": require("../apps/news/views/mobile/home-feed.html")
    };

    this.addTemplate = function(path, value) {
      svc.templates[path] = value;
    };
    this.addTemplates = function(templates) {
      for (var path in templates) {
        svc.addTemplate(path, templates[path]);
      }
    };

    this.$get = [
      function() {
        return svc;
      }
    ];
  }
]);

window.app.directive("ngRequire", [
  "$compile",
  "$parse",
  "ngRequire",
  function($compile, $parse, ngRequire) {
    return {
      restrict: "EA",
      priority: 100000,
      scope: false,
      compile: function($element, $attr, ctrl) {
        var requireAttr =
          $element[0].tagName === "ng-require" ? $attr.src : $attr.ngRequire;
        var key = $parse(requireAttr)(window);
        var template = ngRequire.templates[key];
        if (!template) {
          console.error("Unknown template", key);
        }
        $element.html(template);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/ngRequire.js